<template>
  <v-container fluid>
    <v-row>
      <v-col>
        <h2>
          <v-icon class="mr-2">
            mdi-database-arrow-down
          </v-icon>
          実績報告書用データ
        </h2>
      </v-col>
    </v-row>
    <v-row>
      <v-col>
        <v-expansion-panels v-model="panels">
          <v-expansion-panel>
            <v-expansion-panel-header class="panel-header-color panel-selectable">
              <strong>
                <v-icon class="panel-header-color">
                  mdi-magnify
                </v-icon>
                &nbsp;条件を指定して実行
              </strong>
            </v-expansion-panel-header>
            <v-expansion-panel-content>
              <validation-observer ref="reportGovernmentConditionValidate">
                <v-card flat>
                  <v-card-text>
                    <v-row>
                      <v-col cols="12" md="2">
                        <validation-provider
                          v-slot="{ errors }"
                          name="業者"
                          class="requiredMark"
                        >
                          <v-select
                            v-model="searchForms.traderType"
                            :items="traderTypes"
                            :error-messages="errors"
                            dense
                            hide-details="auto"
                            label="業者"
                            outlined
                            persistent-placeholder
                            rounded
                            style="font-size: 80%"
                            @change="onTraderTypeChange"
                          />
                        </validation-provider>
                      </v-col>
                      <v-col cols="12" md="2">
                        <validation-provider
                          v-slot="{ errors }"
                          name="集計日"
                          class="requiredMark"
                        >
                          <v-select
                            v-model="searchForms.countingDay"
                            :items="countingDays"
                            :error-messages="errors"
                            dense
                            hide-details="auto"
                            label="集計日"
                            outlined
                            persistent-placeholder
                            rounded
                            style="font-size: 80%"
                          />
                        </validation-provider>
                      </v-col>
                      <v-col cols="12" md="2">
                        <validation-provider
                          v-slot="{ errors }"
                          name="産廃物"
                          class="requiredMark"
                        >
                          <v-select
                            v-model="searchForms.itemType"
                            :items="itemTypes"
                            :error-messages="errors"
                            dense
                            hide-details="auto"
                            label="産廃物"
                            outlined
                            persistent-placeholder
                            rounded
                            style="font-size: 80%"
                          />
                        </validation-provider>
                      </v-col>
                      <v-col cols="12" md="2">
                        <validation-provider
                          v-slot="{ errors }"
                          class="requiredMark"
                          rules="required|numeric|max_value:9999"
                          name="報告対象年度"
                        >
                          <v-select
                            v-model="searchForms.fiscalYear"
                            :items="fiscalYears"
                            :error-messages="errors"
                            dense
                            hide-details="auto"
                            label="報告対象年度"
                            outlined
                            persistent-placeholder
                            rounded
                            style="font-size: 80%"
                          />
                        </validation-provider>
                      </v-col>
                      <v-col cols="12" md="2">
                        <validation-provider
                          v-slot="{ errors }"
                          name="都道府県"
                        >
                          <v-autocomplete
                            v-model="searchForms.prefectureCode"
                            :items="prefList"
                            :error-messages="errors"
                            clearable
                            dense
                            hide-details="auto"
                            label="都道府県"
                            outlined
                            persistent-placeholder
                            rounded
                            style="font-size: 80%"
                          />
                        </validation-provider>
                      </v-col>
                    </v-row>
                    <v-row v-if="environment !== 'production'">
                      <v-col cols="3">
                        <v-text-field
                          v-model="searchForms.manifestIds"
                          clearable
                          dense
                          hide-details="auto"
                          label="DXEマニ番号(テスト用です)"
                          outlined
                          persistent-hint
                          persistent-placeholder
                          placeholder="DXEマニ番号をカンマ区切りで入力"
                          hint="例: 1, 2, 3"
                          rounded
                          style="font-size: 80%"
                        />
                      </v-col>
                    </v-row>
                  </v-card-text>

                  <v-card-actions>
                    <v-spacer />
                    <v-btn
                      color="primary"
                      @click="exportButtonClickEvent"
                    >
                      <v-icon>
                        mdi-magnify
                      </v-icon>
                      &nbsp;実行
                    </v-btn>
                  </v-card-actions>
                </v-card>
              </validation-observer>
            </v-expansion-panel-content>
          </v-expansion-panel>
        </v-expansion-panels>
      </v-col>
    </v-row>
    <output-files v-if="enableOutputFile" section="government" />
    <!-- アップグレード誘導モーダル -->
    <ec-contract-single-plan-guide-dialog
      :enable-dialog="enableEcContractSinglePlanGuideDialog"
      :from-report="true"
      @closeCallback="dialogCloseCallback"
    />
    <!-- /アップグレード誘導モーダル -->

  </v-container>
</template>

<script>
import {mapActions, mapGetters, mapState} from "vuex";
import PrefectureList from "../../../../mixins/PrefectureList";
import DownloadMixin from "../../../../mixins/download-mixin";
import OutputFiles from "../_OutputFiles.vue";
import EcContractSinglePlanGuideDialog from '../../dialogs/_EcContractSinglePlanGuideDialog'

export default {
  name: "DriverReportsGovernments",
  components: {
    OutputFiles,
    EcContractSinglePlanGuideDialog,
  },
  mixins: [
    PrefectureList,
    DownloadMixin,

  ],
  props: {},
  data() {
    return {
      environment: process.env.VUE_APP_ENV,
      panels: 0,
      enableOutputFile: true,
      enableEcContractSinglePlanGuideDialog: false,
      searchForms: {
        traderType: "transport",
        countingDay: "collected_date",
        itemType: "iw",
        prefectureCode: null,
        fiscalYear: null,
        manifestIds: null,
      },
      fiscalYears: [],
      /** 業者 */
      traderTypes: [
        { value: "transport", text: "収集運搬業" },
        { value: "disposal",    text: "処分業" },
      ],
      /** 廃棄物 */
      itemTypes: [
        { value: "iw", text: "産廃" },
        { value: "sciw", text: "特管" },
      ],

    }
  },
  computed: {
    ...mapGetters('DriverAuthentication', [
      'loginId'
    ]),
    ...mapState("DriverTenantConfiguration", {
      isEcContractSinglePlan: 'use_ec_contract_single_plan',
    }),
    /** 集計日 */
    countingDays() {
      if (this.searchForms.traderType === "transport") {
        return [
          { value: "collected_date", text: "引渡日" },
          { value: "transport_date", text: "運搬終了日" },
        ];
      } else if (this.searchForms.traderType === "disposal") {
        return [
          { value: "collected_date", text: "引渡日" },
          { value: "disposal_date", text: "処分終了日" },
        ];
      }
      return [];
    },
  },
  created () {
    const systemYear = new Date().getFullYear()
    this.fiscalYears = Array.from({length: 10}, (v, k) => systemYear - k)
    this.searchForms.fiscalYear = systemYear - 1
  },
  methods: {
    ...mapActions("DriverReportGovernment", {
      output: "create",
    }),
    /**
     * 業者変更イベント
     */
    onTraderTypeChange() {
      this.searchForms.countingDay = "collected_date";
    },
    /**
    * 実行ボタン クリックイベント
    */
    exportButtonClickEvent () {

      /** 電子契約単体プランの場合、メッセージを出して終わる */
      if (this.isEcContractSinglePlan) {
        this.enableEcContractSinglePlanGuideDialog = true
      } else {
        this.$refs.reportGovernmentConditionValidate.validate().then((result) => {
          if(result) {
            const params = this._buildParams()
            this.output({ conditions: params}).then((content) => {
              this.enableOutputFile = false;
              this.$nextTick(() => (this.enableOutputFile = true));
              // this.downloadCsv(content, "行政報告用データ出力")
            })
          }
        })
      }
    },
    /**
     * ダイアログ 閉じるボタンコールバック
     */
     dialogCloseCallback () {
      this.enableEcContractSinglePlanGuideDialog = false
    },
    _buildParams() {
      return {
        trader_type: this.searchForms.traderType,
        counting_day: this.searchForms.countingDay,
        item_type: this.searchForms.itemType,
        fiscal_year: this.searchForms.fiscalYear,
        prefecture_code: this.searchForms.prefectureCode,
        manifest_ids: this.searchForms.manifestIds,
      }
    }
  }

}
</script>

